import React, { useRef } from 'react';

import { iconConstants } from '@/constants';
import Icons from '@/icons';
import { Backdrop, Button } from '@/kaya';

import styles from './uploadMusicPopup.module.scss';

interface UploadMusicPopupProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  title: string;
  description: string;
  description2: string;
  btnText: string;
  // formvalues?: uploadMusicTypes.UploadMusic;
  handleChange: (id: string) => (val: string | object) => void;
  setIsSongsDetails: (visible: boolean) => void;
}

const UploadMusicPopup = (props: UploadMusicPopupProps) => {
  const {
    visible,
    setVisible,
    title,
    description,
    description2,
    btnText,
    handleChange,
    setIsSongsDetails,
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const hadnleAudio = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    handleChange('media')(file);
    setVisible(false);
    setIsSongsDetails(true);
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files[0];

    const fileType = file?.type.split('/')[0];

    if (fileType !== 'audio') {
      return;
    }

    if (!file) {
      return;
    }

    handleChange('media')(file);
    setVisible(false);
    setIsSongsDetails(true);
  };

  return visible ? (
    <div>
      <Backdrop visible={visible} setVisible={setVisible} />
      <div
        className={styles.uploadMusicPopup}
        onDragEnter={handleDrag}
        onDragOver={handleDrag}
        onDragLeave={handleDrag}
        onDrop={handleDrop}
      >
        <div className={styles.border}>
          <p className={styles.UploadMusic}>{title}</p>
          <div
            className={styles.upload}
            onClick={() => {
              inputRef.current?.click();
            }}
          >
            <Icons type={iconConstants.ICONS.BIG_UPLOAD} />
          </div>
          <p className={styles.filesUpload}>{description}</p>
          <p className={styles.privateText}>{description2}</p>
          <Button
            type="Primary"
            width="200px"
            onClick={() => {
              inputRef.current?.click();
            }}
          >
            {btnText}
          </Button>
        </div>
        <input
          type="file"
          accept="audio/*"
          style={{ display: 'none' }}
          ref={inputRef}
          onChange={hadnleAudio}
          draggable
        />
      </div>
    </div>
  ) : null;
};

export default UploadMusicPopup;
